import { toggles, lineItemNames, SUBCLASSWALLPAPER } from '../constants';

const { PANEL, BLOCK, SHEET, BAG } = lineItemNames;
const shouldDisplayQuantityCalculator = ({ fulfillment, installServices }) => {
  return !!(fulfillment?.fulfillmentOptions
    && !installServices?.scheduleAMeasure);
};

export const shouldDisplayPipCalculator = ({ fulfillment, info, installServices }) => {
  return !!info?.pipCalculator
      && !!info.pipCalculator.display
      && !!info.pipCalculator.toggle
      && !!info.pipCalculator.coverageUnits
      && !!info.pipCalculator.publisher
      && shouldDisplayQuantityCalculator({ fulfillment, installServices });
};

const returnCalculatorType = (toggle) => {
  if (toggle === toggles.TWO_POINT) return 'Area';
  if (toggle === toggles.THREE_POINT) return 'Volume';
  return '';
};

const getLineItemName = (coverageUnits) => {
  if (coverageUnits === PANEL || coverageUnits === BLOCK || coverageUnits === SHEET) {
    return 'Wall';
  }
  if (coverageUnits === BAG) {
    return 'Space';
  }
  return 'Area';
};

const getCaseUnitOfMeasure = (toggle) => {
  if (toggle === toggles.TWO_POINT) {
    return 'sq. ft.';
  }
  if (toggle === toggles.THREE_POINT) {
    return 'cu. ft.';
  }
  return '';
};

const getDimensionNames = (coverageUnits) => {
  if (coverageUnits === BLOCK) {
    return ['Width', 'Height'];
  }
  if (coverageUnits === SHEET || coverageUnits === BAG) {
    return ['Width', 'Length'];
  }
  return ['Length', 'Width'];
};

export const getPIPCalculatorProps = ({ info }) => {
  const { toggle, coverageUnits, publisher } = info.pipCalculator;
  const wallpaperCalc = info?.subClassNumber === SUBCLASSWALLPAPER;

  return {
    calcProps: {
      calculatorType: returnCalculatorType(toggle),
      lineItemName: getLineItemName(coverageUnits),
      dimensionNames: getDimensionNames(coverageUnits),
      maxAreaNumber: wallpaperCalc ? 8 : 3
    },
    resultsProps: {
      caseUnitOfMeasure: getCaseUnitOfMeasure(toggle),
      unitsPerCase: publisher,
      uom: coverageUnits
    }
  };
};